/* Em detalhes · tema v3 · gerado por tema/detalhes.py a partir da prévia aprovada (proposta-G-pontos). */

/* ======================================================================
   O LEQUE (o único gesto da seção) — da proposta A/E/F.
   Mecanismo de `pasta-de-projeto` / `pasta-macos` (Biblioteca Ryse): um --a só,
   e o toque TRAVA o estado (no celular não existe hover).
   Lição de `pilha-que-abre`: sem hover — o navegador dispara pointerenter sozinho
   no carregamento quando o cursor já está por cima. Quem abre é a chegada na
   tela (uma vez) ou o botão / toque da pessoa.
   (O contador-crescente da F saiu: o número agora mora só na legenda do leque.)
   ====================================================================== */
(function(){
  var reduz = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var sec  = document.querySelector('#detalhes .det');
  var card = sec.querySelector('.lq'), cena = card.querySelector('.dt-cena');
  if (sec.dataset.tipo === 'acessorio') return;   /* acessório: foto parada, sem leque */
  function por(v){
    cena.style.setProperty('--a', v);
    card.dataset.aberta = v ? '1' : '0';
  }
  var aberta = false;
  /* o leque abre uma vez, ao chegar na tela, e não volta para a caixa (pedido do Romulo) */
  window.ryseLeque = function(v){ aberta = !!v; por(v); };   /* só para os testes */

  if (reduz || !('IntersectionObserver' in window)) { aberta = true; por(1); }
  else {
    por(0);
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (e.isIntersecting){ io.disconnect(); setTimeout(function(){ if(!aberta){ aberta = true; por(1); } }, 180); }
      });
    }, { threshold: .55 });
    io.observe(cena);
  }
})();

/* ======================================================================
   Comparador: mecanismo copiado de `comparador-antes-depois` (Biblioteca Ryse), via C/E/F.
   Pointer Events + setPointerCapture, touch-action:none, role=slider com setas/Shift/Home/End.
   Acréscimos da C mantidos: contorno da caixa sobre a obra e os atalhos Caixa/Montado.
   Tirado de propósito: o "convite" que a C animava sozinho — o gesto da seção é o leque.
   (G: as etiquetas "Caixa"/"Montado" sobre a imagem saíram do HTML; o código já as tratava como opcionais.)
   ====================================================================== */
(function(){
var RM=window.matchMedia('(prefers-reduced-motion: reduce)');
function ligar(raiz){
  if(raiz.dataset.ryseCmpPronto)return; raiz.dataset.ryseCmpPronto='1';
  var pega=raiz.querySelector('.ryse-cmp__pega'), arrastando=false, anim=0;
  var sec=raiz.closest('.det'), btns=sec.querySelectorAll('.lg button');
  var alvoFixo=null, bolo=raiz.querySelector('.ryse-cmp__bolo');
  var cx=raiz.querySelector('.cx--sobre'), tA=raiz.querySelector('.ryse-cmp__tag--antes'), tD=raiz.querySelector('.ryse-cmp__tag--depois');
  function pos(p){
    p=Math.max(0,Math.min(100,p));
    raiz.style.setProperty('--ryse-cmp-pos',p+'%');
    if(pega)pega.setAttribute('aria-valuenow',Math.round(p));
    /* o contorno da caixa só aparece onde a obra já cobriu (da C) */
    if(cx){var w=cx.offsetWidth,W=raiz.offsetWidth,l=W-w;
      var sb=w?Math.max(0,Math.min(100,(p/100*W-l)/w*100)):0;
      cx.style.setProperty('--sobre',sb+'%'); cx.firstChild.style.color=sb>70?'#fff':'transparent';}
    var lado = alvoFixo !== null ? alvoFixo : (p <= 2 ? 0 : p >= 98 ? 100 : -1);
    btns[0].setAttribute('aria-pressed',lado===0?'true':'false');
    btns[1].setAttribute('aria-pressed',lado===100?'true':'false');
    if(bolo){ var W2=raiz.offsetWidth, x=p/100*W2, r=bolo.offsetWidth/2+2;
      bolo.style.transform='translateX('+(x<r ? r-x : x>W2-r ? (W2-r)-x : 0)+'px)'; }
    if(tA)tA.style.opacity=p>78?0:1; if(tD)tD.style.opacity=p<24?0:1;
  }
  function para(){ if(anim){cancelAnimationFrame(anim);anim=0;} alvoFixo=null; }
  function ir(alvo,ms){
    para();
    var de=parseFloat(pega.getAttribute('aria-valuenow'))||0;
    alvoFixo=alvo;
    if(RM.matches||!ms){pos(alvo);alvoFixo=null;return;}
    var t0=performance.now();
    (function q(t){var k=Math.min(1,(t-t0)/ms), e=k<.5?4*k*k*k:1-Math.pow(-2*k+2,3)/2;
      pos(de+(alvo-de)*e); if(k<1)anim=requestAnimationFrame(q); else {anim=0;alvoFixo=null;pos(alvo);}})(t0);
  }
  function daEvento(x){var r=raiz.getBoundingClientRect();return ((x-r.left)/r.width)*100;}
  raiz.addEventListener('pointerdown',function(e){
    para(); arrastando=true; raiz.setPointerCapture(e.pointerId); pos(daEvento(e.clientX));
  });
  raiz.addEventListener('pointermove',function(e){ if(arrastando)pos(daEvento(e.clientX)); });
  function parar(e){
    if(!arrastando)return; arrastando=false;
    try{raiz.releasePointerCapture(e.pointerId);}catch(_){}
  }
  raiz.addEventListener('pointerup',parar);
  raiz.addEventListener('pointercancel',parar);
  if(pega)pega.addEventListener('keydown',function(e){
    para();
    var atual=parseFloat(pega.getAttribute('aria-valuenow'))||50;
    var passo=e.shiftKey?10:1, tratou=true;
    switch(e.key){
      case 'ArrowLeft': case 'ArrowDown': pos(atual-passo); break;
      case 'ArrowRight':case 'ArrowUp':   pos(atual+passo); break;
      case 'Home': pos(0); break;
      case 'End':  pos(100); break;
      default: tratou=false;
    }
    if(tratou)e.preventDefault();
  });
  btns.forEach(function(b){ b.addEventListener('click',function(){ ir(+b.dataset.ir,700); }); });
  window.addEventListener('resize',function(){pos(parseFloat(pega.getAttribute('aria-valuenow'))||0);});
  pos(sec.dataset.tipo==='acessorio'?0:62);
}
function bota(){document.querySelectorAll('[data-ryse-cmp]').forEach(ligar);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',bota); else bota();
})();

/* vídeo (da B/E/F): toca mudo quando aparece; com "Reduzir movimento" fica parado no poster */
(function(){
  var s=document.querySelector('#detalhes .det'); if(s.dataset.video==='0') return;
  var v=document.querySelector('#detalhes .det video'); if(!v) return;
  var bp=document.querySelector('#detalhes .det [data-acao="play"]'), bs=document.querySelector('#detalhes .det [data-acao="som"]');
  var reduzido=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var icPause=bp.innerHTML, icPlay='<svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d="M4.5 2.8v10.4L13 8z"/></svg>';
  function marca(){ var p=v.paused; bp.innerHTML=p?icPlay:icPause; bp.setAttribute('aria-label',p?'Reproduzir vídeo':'Pausar vídeo'); }
  bp.onclick=function(){ v.paused?v.play():v.pause(); };
  bs.onclick=function(){ v.muted=!v.muted; bs.setAttribute('aria-label',v.muted?'Ligar som':'Desligar som'); bs.style.background=v.muted?'':'#C30058'; };
  v.addEventListener('play',marca); v.addEventListener('pause',marca); marca();
  if(!reduzido){ new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting?v.play().catch(function(){}):v.pause(); }); },{threshold:.35}).observe(v); }
})();


/* ======================================================================
   OS PONTOS DO LEQUE — mecanismo de `abas-indicador` (Biblioteca Ryse), copiado:
   aria-selected + tabIndex 0/-1 (uma parada de Tab só), setas esquerda/direita
   com volta, painel troca por `hidden`, sem transição.
   Adaptado: não há indicador que viaja (o "indicador" é o próprio ponto, que fica rosa)
   e a ordem das abas é a do número, não a do HTML.
   ====================================================================== */
(function(){
  var sec = document.querySelector('#detalhes .det');
  if (sec.dataset.tipo === 'acessorio') return;
  var bts = [].slice.call(sec.querySelectorAll('.dt-cena [role="tab"]'))
    .sort(function(a,b){ return a.dataset.i - b.dataset.i; });
  var pns = bts.map(function(b){ return document.getElementById(b.getAttribute('aria-controls')); });
  function ir(i){
    bts.forEach(function(b, k){
      var on = k === i;
      b.setAttribute('aria-selected', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
      if (pns[k]) pns[k].hidden = !on;
    });
  }
  bts.forEach(function(b, i){
    b.addEventListener('click', function(e){ ir(i); });
    b.addEventListener('keydown', function(e){
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
      if (!d) return;
      e.preventDefault();
      var n = (i + d + bts.length) % bts.length;
      bts[n].focus(); ir(n);
    });
  });
  ir(Math.max(0, bts.findIndex(function(b){ return b.getAttribute('aria-selected') === 'true'; })));
  window.ryseAba = ir;   /* só para os testes */

  /* tocar no OBJETO também escolhe (não só no número). A caixa é uma foto quadrada de fundo
     branco em multiply, então a área dela é o miolo da foto (sem as margens brancas), e as
     peças e o pôster, que ficam na frente, têm prioridade. */
  var cena = sec.querySelector('.dt-cena');
  var alvos = [
    { el: sec.querySelector('.pecas'),    aba: 'pt-1', folga: 0 },
    { el: sec.querySelector('.poster'),   aba: 'pt-2', folga: 0 },
    { el: sec.querySelector('.caixa img'), aba: 'pt-3', folga: .16 }
  ].filter(function(a){ return a.el; });
  function qual(x, y){
    for (var k = 0; k < alvos.length; k++){
      var r = alvos[k].el.getBoundingClientRect(), f = alvos[k].folga;
      var l = r.left + r.width * f, t = r.top + r.height * f, rr = r.right - r.width * f, b = r.bottom - r.height * f;
      if (x >= l && x <= rr && y >= t && y <= b) return bts.indexOf(document.getElementById(alvos[k].aba));
    }
    return -1;
  }
  cena.addEventListener('click', function(e){
    if (e.target.closest('[role="tab"]')) return;          /* o número já trata */
    var i = qual(e.clientX, e.clientY);
    if (i >= 0) ir(i);
  });
  /* no computador, a mãozinha só aparece em cima de um objeto */
  cena.addEventListener('mousemove', function(e){
    cena.classList.toggle('sobre-obj', qual(e.clientX, e.clientY) >= 0);
  });
  cena.addEventListener('mouseleave', function(){ cena.classList.remove('sobre-obj'); });
})();
